/**
 *
 * ConfirmationModal
 *
 */

import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import { FormattedMessage } from 'react-intl';
import messages from './messages';

type ConfirmationModalProps = {
  title?: React.ReactNode;
  text?: React.ReactNode;
  onCancel: () => void;
  cancelLabel?: React.ReactNode;
  onConfirm: () => void;
  confirmLabel?: React.ReactNode;
  open?: boolean;
  isConfirming?: boolean;
};

const ConfirmationModal = ({
  open = false,
  onCancel,
  onConfirm,
  isConfirming = false,
  title = '',
  text = '',
  cancelLabel = <FormattedMessage {...messages.cancelButton} />,
  confirmLabel = <FormattedMessage {...messages.confirmButton} />,
}: ConfirmationModalProps) => (
  <Dialog
    open={open}
    onClose={onCancel}
    aria-labelledby="confirmation-modal-title"
    aria-describedby="confirmation-modal-description"
    fullWidth
  >
    <DialogTitle id="confirmation-modal-title">{title}</DialogTitle>
    <DialogContent>
      <DialogContentText id="confirmation-modal-description" component="div">
        {text}
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel} color="primary">
        {cancelLabel}
      </Button>
      <Button onClick={onConfirm} color="primary" disabled={isConfirming}>
        {confirmLabel}
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmationModal;
